import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

const ContextMenuContext = createContext(null);

export function ContextMenuProvider({ children }) {
  const [menu, setMenu] = useState(null);

  const closeMenu = useCallback(() => setMenu(null), []);

  const openMenu = useCallback((event, payload, ownerId) => {
    event.preventDefault();
    event.stopPropagation();
    setMenu({
      x: event.clientX,
      y: event.clientY,
      payload,
      ownerId,
    });
  }, []);

  useEffect(() => {
    if (!menu) return undefined;

    const dismiss = () => closeMenu();
    const onKey = (e) => {
      if (e.key === 'Escape') dismiss();
    };

    document.addEventListener('click', dismiss);
    document.addEventListener('keydown', onKey);
    // Capture: close before the next contextmenu handler opens a replacement menu.
    document.addEventListener('contextmenu', dismiss, true);

    return () => {
      document.removeEventListener('click', dismiss);
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('contextmenu', dismiss, true);
    };
  }, [menu, closeMenu]);

  const value = useMemo(
    () => ({ menu, openMenu, closeMenu }),
    [menu, openMenu, closeMenu]
  );

  return (
    <ContextMenuContext.Provider value={value}>
      {children}
    </ContextMenuContext.Provider>
  );
}

export function useContextMenuContext() {
  const ctx = useContext(ContextMenuContext);
  if (!ctx) {
    throw new Error('useContextMenu must be used within ContextMenuProvider');
  }
  return ctx;
}
